module.exports = __webpack_public_path__ + "static/bitcointalk-icon-1a9ade6ddd9f07da1d64555fdd48fea3.png";